export default "__VITE_ASSET__hcM7_cDd__"